define.alias("shared/components/shared/ui/switcher/option", "calendar/components/shared/ui/switcher/option");